import React from "react";
import About from "./components/about/About";
import BackToTop from "./components/BackToTop";
import Contact from "./components/contact/Contact";
import Services from "./components/services/Services";
import Experience from "./components/experience/Experience";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Nav from "./components/nav/Nav";
import Portfolio from "./components/portfolio/Portfolio";
import ScrollProgress from "./components/ScrollProgress";
import useReveal from "./useReveal";

const App = () => {
  useReveal();

  return (
    <>
      <ScrollProgress />
      <Nav />
      <main>
        <Header />
        <About />
        <Experience />
        <Services />
        <Portfolio game={true} />
        <Portfolio game={false} title="Fun Projects" subtitle="" />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
};

export default App;
